import React, { useState, lazy, Suspense, useEffect } from "react";
import styles from "./AddManager.module.css";
import { THEME, useAuth } from "../../components/context/Auth";
import {
  EditManagerIcon,
  LockIcon2,
  ManagerLogOffIcon,
  ManagerLogOutIcon,
  RemoveAccountIcon,
} from "../../components/icons/Icon";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import CryptoJS from "crypto-js";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import ToggleBtn from "../../components/updatedComponents/FormComponents/ToggleBtn";
import ProgressBar from "../../components/updatedComponents/Manager/ProgressBar";
import fetchData from "../../APIsControll/apiControll";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import RadioButtonGroup from "../../components/updatedComponents/FormComponents/RadioButtonGroup";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { decryptData, encryptData } from "../../Encryption/Encryption";
import { useDispatch, useSelector } from "react-redux";
import { setdragMode } from "../../store/slices/layout/LayoutSlice";
import { Done, Refresh, Reorder } from "../../components/icons/Icon2";

const Button = lazy(
  () => import("../../components/updatedComponents/Dealers/Button"),
);

const AddManager = () => {
  const { dragMode } = useSelector((item) => item.layout);
  const {
    mode,
    managerId,
    selectedTheme,
    toggleTheme,
    handleSignOut,
    designations,
  } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataInsert, setDataInsert] = useState({
    name: "",
    mobile: "",
    email:"",
    loginId: "",
    password: "",
    confirmPassword: "",
    status: "",
  });
  const [Isloading, setIsLoading] = useState({ loading1: false });
  // const { deviceId, } = useDeviceInfo();
  const [searchParams] = useSearchParams();
  const manager_Id = searchParams.get("manager_Id");
  const path = location.pathname;

  const encryptedLoginId = sessionStorage.getItem("loginID")
    ? sessionStorage.getItem("loginID")
    : "";
  const decryptedBytes = CryptoJS.AES.decrypt(encryptedLoginId, "secret key");
  const loginId = decryptedBytes.toString(CryptoJS.enc.Utf8).slice(1, -1);

  useEffect(() => {
    const getManager = async () => {
      const apiData = {
        managerId: managerId,
        id: manager_Id,
      };

      const result = await fetchData("managers/getManager", apiData);

      if (result.status === "success") {
        setDataInsert((prevState) => ({
          ...prevState,
          name: result.data.name,
          mobile: result.data.mobile,
          email:result.data.email,
          loginId: result.data.loginId,
          status: result.data.status,
          designation: result.data.designation,
          selectedWarehouse: result.data.selectedWarehouse,
          selectedState: result.data.selectedState,
        }));
      } else {
        alert(result.msg);
      }
    };
    if (managerId && manager_Id && path !== "/profile") {
      getManager();
    }
  }, [managerId, manager_Id, path]);
  useEffect(() => {
    const getLoggedInManagerData = async () => {
      try {
        const result = await fetchData("managers/managerProfile", {
          loginId: localStorage.getItem("loginID"),
        });
        if (result.status === "success") {
          setDataInsert((prevState) => ({
            ...prevState,
            name: result.data.name,
            mobile: result.data.mobile,
            email:result.data.email,
            loginId: result.data.loginId,
            status: result.data.status,
            designation: result.data.designation,
            selectedWarehouse: result.data.selectedWarehouse,
            selectedState: result.data.selectedState,
          }));
        } else {
          console.error("Failed to fetch user data: ", result.msg);
        }
      } catch (error) {
        //console.log("Error while fetching user data ", error);
      }
    };
    if (loginId && (path === "/profile" || path === "/")) {
      getLoggedInManagerData();
    }
  }, [loginId, path]);

  useEffect(() => {
    return () => {
      setDataInsert({
        name: "",
        mobile: "",
        email:"",
        loginId: "",
        password: "",
        confirmPassword: "",
        status: "",
      });
    };
  }, []);

  const handlLogOff = async () => {
    try {
      const payload = {
        deviceId: localStorage.getItem("UnDeviceId"),
        loginId: localStorage.getItem("loginID"),
      };
      setIsLoading({ ...Isloading, loading1: true });
      const result = await fetchData(`managers/logoutDevice`, {
        payload: encryptData(payload),
      });
      const res = decryptData(result.res);
      if (res?.status === "success") {
        handleSignOut();
        setIsLoading({ ...Isloading, loading1: false });
        return;
      }
      if (res?.status === "failed") {
        setIsLoading({ ...Isloading, loading1: false });
        return;
      } else {
        setIsLoading({ ...Isloading, loading1: false });
        return;
      }
    } catch (error) {
      setIsLoading({ ...Isloading, loading1: false });
    }
  };

  const formatTabText = (d) => {
    if (typeof d !== "string") {
      return d;
    }

    if (d === "superadmin") {
      return "Super Admin";
    }

    const isManager = d.endsWith("manager");
    let formatted = d;

    if (isManager) {
      const baseName = d.slice(0, -7);
      const capitalizedBaseName = baseName
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      formatted = `${capitalizedBaseName} Manager`;
    }
    return formatted;
  };

  return (
    <>
      <div className={`${styles.am} ${mode ? styles.am_dark : ""}`}>
        <div className={styles.am_top}>
          <div className={styles.am_top_left}>
            <TopTabBar
              text={
                path === "/profile" || path === "/"
                  ? "Profile"
                  : "Managers / Manager Profile / " + dataInsert.name
              }
            />
          </div>

          <div className={styles.am_top_left}>
            <Suspense fallback={<div>Loading..</div>}>
              {path === "/profile" || path === "/" ? (
                <>
                  {designations.includes("superadmin") ||
                  designations.length <= 1 ? null : (
                    <Button
                      buttonIcon={
                        dragMode ? <Done /> : <Reorder color={"#fff"} />
                      }
                      buttonText={dragMode ? "Done" : "Re Arrange"}
                      buttonBgColor={dragMode ? "#8d8b11ff" : "#4164E3"}
                      buttonTextColor={"#ffffff"}
                      buttonBorder={"none"}
                      buttonClick={() => {
                        dispatch(setdragMode(!dragMode));
                      }}
                    />
                  )}
                  <Button
                    buttonIcon={<RemoveAccountIcon />}
                    buttonText={"Remove Account"}
                    buttonBgColor={"#000000"}
                    buttonTextColor={"#ffffff"}
                    buttonBorder={"none"}
                    buttonClick={() => {
                      setIsModalOpen(true);
                    }}
                  />
                  <Button
                    buttonIcon={<LockIcon2 />}
                    buttonText={"Lock"}
                    buttonBgColor={"#F93E3E"}
                    buttonTextColor={"#ffffff"}
                    buttonBorder={"none"}
                    buttonClick={handleSignOut}
                  />
                  <ModalWrapper
                    isOpen={isModalOpen}
                    onClose={() => {
                      setIsModalOpen(false);
                    }}
                    noBtn
                  >
                    <ManagerModal
                      heading={"Logout Device"}
                      centerHeading={"Are you sure want to Logout?"}
                      subHeading={"To confirm! type logout in the text field."}
                      targetWord={"logout"}
                      handleCloseModal={() => setIsModalOpen(false)}
                      handleSubmit={() => {
                        handlLogOff();
                      }}
                      focus={isModalOpen}
                    />
                  </ModalWrapper>
                </>
              ) : (
                <>
                  <Button
                    buttonIcon={<EditManagerIcon color={"#ffffff"} />}
                    buttonText={"Edit"}
                    buttonBgColor={"#4164E3"}
                    buttonTextColor={"#ffffff"}
                    buttonBorder={"none"}
                    buttonClick={() =>
                      navigate(`/managers/newmanager/${manager_Id}`)
                    }
                  />
                </>
              )}
            </Suspense>
          </div>
        </div>

        <div
          className={` ${styles.am_details} ${styles.am_bg} ${
            mode ? styles.am_bg_dark : ""
          }`}
        >
          <div className={styles.am_profile_text}>
            <div className={styles.am_photo}>
              <div
                className={styles.First_text}
                style={{ color: mode ? "#fff" : "#000" }}
              >
                {dataInsert.name.charAt(0).toUpperCase()}
              </div>
            </div>

            <Suspense fallback={<div>Loading..</div>}>
              <div className={styles.am_profile_text_container}>
                <div>
                  <TextElement
                    label={"Name:"}
                    value={dataInsert.name}
                    labelColor={mode ? "#9C9797" : "#646B88"}
                    valueColor={mode ? "#fff" : "#000000"}
                  />
                  <TextElement
                    label={"Designations:"}
                    value={dataInsert.designation}
                    labelColor={mode ? "#9C9797" : "#646B88"}
                    valueColor={mode ? "#fff" : "#000000"}
                  />
                  <TextElement
                    label={"Mobile:"}
                    value={dataInsert.mobile}
                    labelColor={mode ? "#9C9797" : "#646B88"}
                    valueColor={mode ? "#fff" : "#000000"}
                  />
                   <TextElement
                    label={"Email:"}
                    value={dataInsert.email}
                    labelColor={mode ? "#9C9797" : "#646B88"}
                    valueColor={mode ? "#fff" : "#000000"}
                  />
                </div>
                <div>
                  <TextElement
                    label={"Worked Hour:"}
                    value={"08:00 Hr"}
                    labelColor={mode ? "#9C9797" : "#646B88"}
                    valueColor={mode ? "#fff" : "#000000"}
                  />
                  <TextElement
                    label={"Shift:"}
                    value={"Shift 1"}
                    labelColor={mode ? "#9C9797" : "#646B88"}
                    valueColor={mode ? "#fff" : "#000000"}
                  />
                  <TextElement
                    label={"Date:"}
                    value={"12-07-2024"}
                    labelColor={mode ? "#9C9797" : "#646B88"}
                    valueColor={mode ? "#fff" : "#000000"}
                  />
                </div>
                <div>
                  <div className={styles.am_work_status_section}>
                    <p
                      className={
                        mode
                          ? styles.am_dark_mode_text
                          : styles.am_light_mode_text
                      }
                    >
                      {" "}
                      Work Status<span className={styles.mandatory}>*</span>
                    </p>

                    <ToggleBtn status={dataInsert.status} />
                  </div>
                  {designations.includes("superadmin") ||
                  !localStorage.getItem("dashboardRoute") ? null : (
                    <div style={{ width: "80%", marginLeft: "auto" }}>
                      <Suspense fallback={<div>Loading..</div>}>
                        <Button
                          buttonIcon={<Refresh mode={mode ? "#fff" : "#000"} />}
                          buttonText={"RESET MENU TAB"}
                          buttonBgColor={"#000"}
                          buttonTextColor={"#ffffff"}
                          buttonBorder={"none"}
                          buttonClick={() => {
                            localStorage.removeItem("updatedMenuItems");
                            localStorage.removeItem("dashboardRoute");
                            window.location.reload();
                          }}
                        />
                      </Suspense>
                    </div>
                  )}
                </div>
                {(path === "/profile" || path === "/") && (
                  <>
                    <Link
                      to={"#"}
                      style={{ height: "12px" }}
                      className={
                        mode
                          ? styles.am_dark_mode_link
                          : styles.am_light_mode_link
                      }
                    >
                      Reset your pin
                    </Link>

                    <div className={styles.set_theme}>
                      <p style={{ color: mode ? "#9C9797" : "#646B88" }}>
                        Theme
                      </p>
                      <RadioButtonGroup
                        key={selectedTheme}
                        options={[
                          { value: THEME.SYSTEM, label: "System" },
                          { value: THEME.LIGHT, label: "Light" },
                          { value: THEME.DARK, label: "Dark" },
                        ]}
                        selectedOption={selectedTheme}
                        onChange={(newTheme) => {
                          toggleTheme(newTheme);
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
            </Suspense>
          </div>

          {(path === "/profile" || path === "/") && (
            <div className={styles.am_action_center}></div>
          )}
        </div>

        <div className={styles.am_assignments}>
          <div className={styles.am_assignments_left}>
            <div
              className={`${styles.am_assignment} ${
                mode ? styles.am_bg_dark : ""
              }`}
            >
              <Suspense fallback={<div>Loading..</div>}>
                <p
                  className={
                    mode ? styles.am_dark_mode_text : styles.am_light_mode_text
                  }
                >
                  Assigned Designations
                </p>
                <div
                  className={`${styles.am_list_data} ${
                    mode ? styles.warehouse_list_dark : ""
                  }`}
                >
                  <>
                    {Array.isArray(dataInsert.designation) &&
                    dataInsert.designation.length !== 0 ? (
                      dataInsert.designation.map((d) => (
                        <div key={d}>
                          <Button
                            buttonText={formatTabText(d) || "No Designation"}
                            buttonBgColor={mode ? "#2C2E33" : "#F8F9FC"}
                            buttonTextColor={mode ? "#ffffff" : "#4164E3"}
                            buttonFontWeight={"400"}
                            buttonBorder={"none"}
                            type={"manager"}
                            padding={"1rem"}
                          />
                        </div>
                      ))
                    ) : (
                      <p className={styles.new_manager_go_back_text}>
                        No designation assigned
                      </p>
                    )}
                  </>
                </div>
              </Suspense>
            </div>

            <div
              className={`${styles.am_assignment} ${
                mode ? styles.am_bg_dark : ""
              }`}
            >
              <Suspense fallback={<div>Loading..</div>}>
                <p
                  className={
                    mode ? styles.am_dark_mode_text : styles.am_light_mode_text
                  }
                >
                  Assigned States
                </p>
                <div className={styles.am_list_data}>
                  <>
                    {Array.isArray(dataInsert.selectedState) &&
                    dataInsert.selectedState.length !== 0 ? (
                      dataInsert.selectedState.map((s) => (
                        <div key={s._id}>
                          <Button
                            buttonText={s.stateName}
                            buttonBgColor={mode ? "#2C2E33" : "#F8F9FC"}
                            buttonTextColor={mode ? "#ffffff" : "#4164E3"}
                            buttonFontWeight={"400"}
                            buttonBorder={"none"}
                            type={"manager"}
                            padding={"1rem"}
                          />
                        </div>
                      ))
                    ) : (
                      <p
                        className={
                          mode
                            ? styles.am_dark_mode_text
                            : styles.am_light_mode_text
                        }
                      >
                        No state assigned
                      </p>
                    )}
                  </>
                </div>
              </Suspense>
            </div>

            <div
              className={`${styles.am_assignment} ${
                mode ? styles.am_bg_dark : ""
              }`}
            >
              <Suspense fallback={<div>Loading..</div>}>
                <p
                  className={
                    mode ? styles.am_dark_mode_text : styles.am_light_mode_text
                  }
                >
                  Assigned Warehouse
                </p>
                <div
                  className={`${styles.am_list_data} ${
                    mode ? styles.warehouse_list_dark : ""
                  }`}
                >
                  <>
                    {Array.isArray(dataInsert.selectedWarehouse) &&
                    dataInsert.selectedWarehouse.length !== 0 ? (
                      dataInsert.selectedWarehouse.map((w) => (
                        <div key={w.warehousename}>
                          <Button
                            buttonText={w.warehousename || "No Warehouse"}
                            buttonBgColor={mode ? "#2C2E33" : "#F8F9FC"}
                            buttonTextColor={mode ? "#ffffff" : "#4164E3"}
                            buttonFontWeight={"400"}
                            buttonBorder={"none"}
                            type={"manager"}
                            padding={"1rem"}
                          />
                        </div>
                      ))
                    ) : (
                      <p className={styles.new_manager_go_back_text}>
                        No warehouse assigned
                      </p>
                    )}
                  </>
                </div>
              </Suspense>
            </div>
          </div>

          <div className={styles.am_assignments_right}>
            <div
              className={`${styles.am_assignment} ${
                mode ? styles.am_bg_dark : ""
              }`}
              style={{ maxHeight: "100%" }}
            >
              <Suspense fallback={<div>Loading..</div>}>
                <p
                  className={
                    mode ? styles.am_dark_mode_text : styles.am_light_mode_text
                  }
                >
                  Attendance : Present
                </p>
                <div className={styles.progress_bar_mob}>
                  <div>
                    <ProgressBar currentStep={4} />
                  </div>
                </div>
              </Suspense>
            </div>
          </div>
        </div>

        <div
          className={`${styles.am_footer_mob} ${
            mode ? styles.am_footer_mob_dark : ""
          }`}
        >
          <Suspense fallback={<div>Loading..</div>}>
            {path === "/profile" || path === "/" ? (
              <>
                <Button
                  buttonIcon={<ManagerLogOffIcon />}
                  buttonText={"Logoff"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                />
                <Button
                  buttonIcon={<ManagerLogOutIcon color={"#fff"} />}
                  buttonText={"Logout"}
                  buttonBgColor={"#F93E3E"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={() => handleSignOut()}
                />
              </>
            ) : (
              <Button
                buttonIcon={<EditManagerIcon />}
                buttonText={"Edit"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={() =>
                  navigate(`/managers/newmanager/${manager_Id}`)
                }
              />
            )}
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default AddManager;
